import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Edit = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6036 1.39645C13.7179 0.510834 12.2821 0.510835 11.3964 1.39645L10.647 2.14593L10.6464 2.14645L10.6459 2.14698L5.64645 7.14645C5.59598 7.19692 5.5569 7.25761 5.53184 7.32444L4.03184 11.3244C3.96299 11.508 4.0078 11.7149 4.14645 11.8536C4.28509 11.9922 4.49197 12.037 4.67556 11.9682L8.67556 10.4682C8.74239 10.4431 8.80308 10.404 8.85355 10.3536L13.8536 5.35356L14.6036 4.60356C15.4892 3.71794 15.4892 2.28207 14.6036 1.39645ZM6.43014 7.77698L11 3.20711L12.7929 5.00001L8.22303 9.56987L5.3544 10.6456L6.43014 7.77698ZM11.7071 2.50001L13.5 4.2929L13.8964 3.89645C14.3915 3.40136 14.3915 2.59865 13.8964 2.10356C13.4014 1.60847 12.5986 1.60847 12.1036 2.10356L11.7071 2.50001ZM2.5 3.00001C1.67157 3.00001 1 3.67158 1 4.50001V13.5C1 14.3284 1.67157 15 2.5 15H10.5C11.3284 15 12 14.3284 12 13.5V10C12 9.72386 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.72386 11 10V13.5C11 13.7761 10.7761 14 10.5 14H2.5C2.22386 14 2 13.7761 2 13.5V4.50001C2 4.22386 2.22386 4.00001 2.5 4.00001H6.5C6.77614 4.00001 7 3.77615 7 3.50001C7 3.22386 6.77614 3.00001 6.5 3.00001H2.5Z"
      />
    </svg>
  )
})

export default Edit
